module.exports = __webpack_public_path__ + "assets/img/C-1.150703fe.jpg";